import PropTypes from "prop-types";
import React from "react";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import getClassNameFactory from "../../utilities/classNames";
import OpenInNewTab3 from "@dcl/icons/esm/ui/open-in-new-tab-3-rebranding";

var GlobalFooterItem = function GlobalFooterItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      target = _ref.target,
      ariaLabel = _ref.ariaLabel,
      rel = _ref.rel,
      customIcon = _ref.customIcon,
      showArrowIcon = _ref.showArrowIcon,
      customClass = _ref.customClass,
      showButtonEle = _ref.showButtonEle;
  var getClassName = getClassNameFactory(GlobalFooterItem.displayName);

  var getIconRight = function getIconRight() {
    if (showArrowIcon) {
      return /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "arrow"
        })
      }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
        width: 24
      }));
    } else if (target && target === "_blank") {
      return /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "new-tab-icon"
        })
      }, /*#__PURE__*/React.createElement(OpenInNewTab3, {
        width: 16
      }));
    }
  };

  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, !showButtonEle && /*#__PURE__*/React.createElement("a", {
    className: "".concat(getClassName({
      descendantName: "inner"
    })).concat(customClass ? customClass : ""),
    target: target,
    "aria-label": ariaLabel,
    href: href,
    rel: rel
  }, customIcon && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "custom-icon"
    })
  }, customIcon), title, getIconRight()), showButtonEle && /*#__PURE__*/React.createElement("button", {
    className: "".concat(getClassName({
      descendantName: "inner"
    })).concat(customClass ? customClass : "")
  }, title));
};

GlobalFooterItem.displayName = "GlobalFooterItem";
/* eslint-disable max-len */

GlobalFooterItem.propTypes = {
  /**
   * URL.
   */
  href: PropTypes.string.isRequired,

  /**
   * Title of the item.
   */
  title: PropTypes.string.isRequired,

  /**
   * expose the <a> elements 'target' prop  to the components api
   */
  target: PropTypes.string,

  /**
   * Aria label for the link.
   */
  ariaLabel: PropTypes.string,

  /**
   * 'rel' attribute for link
   */
  rel: PropTypes.string,

  /**
   * Custom icon like social media
   */
  customIcon: PropTypes.node,

  /**
   * Display icon after the text
   */
  showArrowIcon: PropTypes.bool,

  /**
   * custom Class on footer links
   */
  customClass: PropTypes.string,

  /**
   * Dispaly Button inplace of anchor tag
   */
  showButtonEle: PropTypes.bool
};
/* eslint-enable max-len */

export default GlobalFooterItem;